// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconLightningSlash = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.3435 48.8605C38.976 49.5393 39.0722 50.2672 38.6673 51.1019C37.4812 53.5467 36.4334 56.0256 35.5801 58.4881C35.0183 60.1092 32.9865 60.5683 32.0001 59.1645C31.755 58.8157 28.6163 50.9218 28.0001 39.9968L9.94496 40.0033C8.65248 40.0038 7.69881 38.7557 8.08467 37.5221C9.17207 34.0461 10.8764 30.4603 12.9786 26.959C13.7125 25.7366 15.0249 25.5481 16.0664 26.5218C18.9594 29.2265 22.5726 32.6451 27.0504 36.9498C31.8268 41.9183 35.5136 45.8237 38.3435 48.8605ZM55.3457 49.6887C54.7775 49.1205 51.9461 46.7049 44.9878 40.1966C48.2966 35.2825 51.8851 30.9186 55.1909 27.6888C56.617 26.2953 56.097 24.0049 54.1122 24.0049L34.0001 24.0001C34.3158 16.2059 36.7501 9.25292 37.8379 6.82439C38.6121 5.09588 36.4533 3.31139 34.7919 4.26739C30.3545 6.82097 25.4796 11.0434 21.0471 16.0494C16.5854 11.2247 14.7911 9.13409 14.3115 8.65453C13.4388 7.78185 12.3557 7.78191 11.483 8.65453L8.65462 11.483C7.782 12.3556 7.78194 13.4387 8.65462 14.3114C9.45747 15.1142 14.7687 19.5954 29.8788 34.1213C44.4048 49.2314 48.8859 54.5427 49.6888 55.3456C50.5615 56.2182 51.6446 56.2182 52.5172 55.3456L55.3457 52.5171C56.2183 51.6445 56.2183 50.5614 55.3457 49.6887Z" />
    </svg>
  );
};
